const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_lsex8Hg2h',
  aws_user_pools_web_client_id: 'g4g3i04tnn2gjl07f5uh2g700',
  aws_appsync_dangerously_connect_to_http_endpoint_for_testing: false,
};

export default awsmobile;
